import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { getExpireDate, getUserProfile, getCookie } from "helpers";
import { handleClick } from "@/shared/Analitics/GoogleAnalytics4";

export const useChat = () => {
  const [userMessage, setUserMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userProfile, setUserProfile] = useState(null);

  const { loginWithRedirect, getAccessTokenSilently } = useAuth0();

  const handleForm = (e) => {
    e.preventDefault();
    if (loading) return;
    if(!userProfile?.id) { 
      redirectLogin();
      return;
    }
    // if (userProfile?.subscriptionStatus !== "subscribed") {
    //   window.location.href = `${process.env.NEXT_PUBLIC_DOMAIN_URL}/suscripciones/landing.html`
    //   return;
    // }
    if (!e.target[0].value.trim()) {
      setError("Por favor, ingrese una pregunta");
      return;
    }
    setMessages((prevMessages) => [
      ...prevMessages,
      { type: "user", message: e.target[0].value },
    ]);
    getChat(e.target[0].value.trim());
    setUserMessage("");
  };

  const redirectLogin = async () => {
    handleClick("ui_interaction", "header principal", "Boton Ingresar");
    let expDate = getExpireDate(1);
    document.cookie = `auth0_redir=${
      window.location.href
    };expires=${expDate.toUTCString()};path=/`;
    loginWithRedirect();
  };

  const getChat = async (question) => {
    try {
      setLoading(true);
      setError("");
      const token = await getAccessTokenSilently();
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_DOMAIN_URL}/api/chatRecipe`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-User-Id": userProfile?.id,
            "Authorization": `Bearer ${token}`
          },
          body: JSON.stringify({ question }),
        }
      );
      if (!response.ok) {
        throw new Error(`getChat: ${response.status} ${response.statusText}`);
      }
      const { data } = await response.json();

      if(!data?.mensaje) {
        setError("Error al obtener la respuesta, vuelva a intentarlo");
        return;
      }
      // Agregar el mensaje obtenido al array de mensajes      
      setMessages((prevMessages) => [
        ...prevMessages,
        { type: "ia", message: data.mensaje },
      ]);
    } catch (error) {
      console.log(error);
      setError("Error al obtener la respuesta, vuelva a intentarlo");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const { id, subscriptionStatus } = getUserProfile() ?? {
      id: null,
      subscriptionStatus: null
    };
    setUserProfile({ id, subscriptionStatus });
  }, []);

  return {
    messages,
    loading,
    error,
    userMessage,
    setUserMessage,
    handleForm,
  };
};
